import React from 'react';
import AnalysisPanel from './AnalysisPanel';
import NewsPanel from './NewsPanel';
import DraggableFab from './DraggableFab';

const chartinkUrl = (link) => `https://chartink.com/stocks/${encodeURIComponent(link)}.html`;

const StockInfoPanel = ({
  link, name, sclink, bseCode, nseCode,
  canEditAnalysis = false,
  onPrevious, onNext, canPrevious, canNext,
}) => {
  if (!link) return <div className="order-panel"><div className="chart-empty">Select a stock</div></div>;

  return (
    <div className="order-panel">
      <DraggableFab label="Prev" className="order-heading-prev" storageKey="bse4-prev-fab-pos" onAction={onPrevious} disabled={!canPrevious} />
      <DraggableFab label="Next" className="order-heading-next" storageKey="bse4-next-fab-pos" onAction={onNext} disabled={!canNext} />
      <DraggableFab
        label="Scr"
        className="floating-scr-button"
        storageKey="bse4-scr-fab-pos"
        onAction={() => { if (sclink) window.open(sclink, '_blank', 'noopener'); }}
        disabled={!sclink}
      />
      <DraggableFab
        label="Chrt"
        className="floating-chrt-button"
        storageKey="bse4-chrt-fab-pos"
        onAction={() => { window.open(chartinkUrl(link), '_blank', 'noopener'); }}
      />

      <div className="info-panel-body">
        <div className="info-panel-section">
          <AnalysisPanel link={link} name={name} canEdit={canEditAnalysis} bseCode={bseCode} nseCode={nseCode} />
        </div>
        <div className="info-panel-section">
          <NewsPanel key={bseCode || link} id={bseCode || link} bseCode={bseCode} nseCode={nseCode || link} />
        </div>
      </div>
    </div>
  );
};

export default StockInfoPanel;
